"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBackendIngredientBreakdown = parseBackendIngredientBreakdown;
exports.parseBackendIngredientServings = parseBackendIngredientServings;
exports.parseCustomerFavoriteMenu = parseCustomerFavoriteMenu;
exports.parseMenu = parseMenu;
exports.parseMenus = parseMenus;
exports.parseNutrientAmounts = void 0;
exports.prepareIngredientServings = prepareIngredientServings;
exports.userOrderMenuItems = userOrderMenuItems;
exports.userOrdersMenuItems = userOrdersMenuItems;
var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function parseBackendIngredientServings(backendIngredientServings) {
  return (0, _lodash.chain)(backendIngredientServings).map(function (ingredient) {
    return [ingredient.ingredient, parseFloat(ingredient.serving, 10)];
  }).fromPairs().value();
}
function parseBackendIngredientBreakdown(backendIngredientBreakdown) {
  return (0, _lodash.chain)(backendIngredientBreakdown).map(function (ingredientBreakdown) {
    return _objectSpread(_objectSpread({}, ingredientBreakdown), {}, {
      price: parseFloat(ingredientBreakdown.price),
      serving: parseFloat(ingredientBreakdown.serving),
      singlePrice: parseFloat(ingredientBreakdown.singlePrice),
      total: parseFloat(ingredientBreakdown.total),
      discountAmount: parseFloat(ingredientBreakdown.discountAmount)
    });
  }).value();
}
function prepareIngredientServings(frontendIngredientServings) {
  var backendIngredientServings = [];
  Object.keys(frontendIngredientServings).forEach(function (ingdId) {
    return backendIngredientServings.push({
      ingredient: ingdId,
      serving: frontendIngredientServings[ingdId]
    });
  });
  return backendIngredientServings;
}
function parseMenu(menu, menuGroupId) {
  var menuItem = {};
  var menuItemIngredientServings = {};
  var frontendIngredientServings = parseBackendIngredientServings(menu.ingredients);
  menuItemIngredientServings["".concat(menu.id, "_").concat(menuGroupId)] = frontendIngredientServings;
  menuItem["".concat(menu.id, "_").concat(menuGroupId)] = _objectSpread(_objectSpread({}, menu), {}, {
    apiId: menu.id,
    id: "".concat(menu.id, "_").concat(menuGroupId),
    menuGroupId: menuGroupId,
    price: parseFloat(menu.price),
    ingredients: undefined,
    ingredientServings: frontendIngredientServings
  });
  return {
    menuItem: menuItem,
    menuItemIngredientServings: menuItemIngredientServings
  };
}
function parseCustomerFavoriteMenu(menu) {
  var ingredientServings = parseBackendIngredientServings(menu.ingredients);
  var favoriteMenuItem = _objectSpread(_objectSpread({}, menu), {}, {
    apiId: menu.menu,
    price: null,
    flags: [],
    personalSettings: [menu.personalSettings],
    ingredient: undefined,
    ingredientServings: ingredientServings,
    isFavorite: true
  });
  return {
    favoriteMenuItem: favoriteMenuItem,
    ingredientServings: ingredientServings
  };
}
function userOrderMenuItems(userOrder) {
  var menuItems = {};
  var menuItemIngredientServings = {};
  userOrder.ordermenu.map(function (userOrderItem) {
    var result = parseMenu(userOrderItem.menu);
    menuItems = _objectSpread(_objectSpread({}, menuItems), result.menuItem);
    menuItemIngredientServings = _objectSpread(_objectSpread({}, menuItemIngredientServings), result.menuItemIngredientServings);
    return userOrderItem;
  });
  return {
    menuItems: menuItems,
    menuItemIngredientServings: menuItemIngredientServings
  };
}
function userOrdersMenuItems(userOrders, food) {
  var menuItems = {};
  var menuItemIngredientServings = {};
  userOrders.map(function (userOrder) {
    var result = userOrderMenuItems(userOrder, food);
    menuItems = _objectSpread(_objectSpread({}, menuItems), result.menuItems);
    menuItemIngredientServings = _objectSpread(_objectSpread({}, menuItemIngredientServings), result.menuItemIngredientServings);
    return userOrder;
  });
  return {
    menuItems: menuItems,
    menuItemIngredientServings: menuItemIngredientServings
  };
}
function parseMenus(menus, menuGroupId) {
  var menuItems = {};
  var menuItemIngredientServings = {};
  var apiIdMenuItemNames = {};
  menus.map(function (menu) {
    var result = parseMenu(menu, menuGroupId);
    menuItems = _objectSpread(_objectSpread({}, menuItems), result.menuItem);
    menuItemIngredientServings = _objectSpread(_objectSpread({}, menuItemIngredientServings), result.menuItemIngredientServings);
    apiIdMenuItemNames[menu.id] = menu.name;
    return menu;
  });
  return {
    apiIdMenuItemNames: apiIdMenuItemNames,
    menuItems: menuItems,
    menuItemIngredientServings: menuItemIngredientServings
  };
}
var parseNutrientAmounts = exports.parseNutrientAmounts = function parseNutrientAmounts(nutrients) {
  return (0, _lodash.chain)(nutrients).mapValues(function (nutrient) {
    return nutrient.amount;
  }).value();
};